import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const QuizDiagnosticsNoAccessState = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <Container>
      <Card>
        <IconCircle aria-hidden='true'>
          <LockIcon viewBox='0 0 24 24' focusable='false'>
            <path d='M18 8h-1V6a5 5 0 0 0-10 0v2H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2ZM9 6a3 3 0 1 1 6 0v2H9V6Zm9 14H6V10h12v10Z' />
          </LockIcon>
        </IconCircle>

        <StatusBadge>{t('quizDiagnostics.noAccess.badge')}</StatusBadge>

        <ContentBlock>
          <Title>{t('quizDiagnostics.noAccess.header')}</Title>
          <Description>{t('quizDiagnostics.noAccess.description')}</Description>
          <ContactNote>{t('quizDiagnostics.noAccess.contactAdmin')}</ContactNote>
        </ContentBlock>
      </Card>
    </Container>
  )
}

export default QuizDiagnosticsNoAccessState

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 320px;
  box-sizing: border-box;
`

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 560px;
  padding: 40px 32px;
  border-radius: ${({ theme }) => theme.shape.borderRadiusBig};
  box-shadow: ${({ theme }) => theme.shadows.darkShadow};
  background: ${({ theme }) => theme.colors.backgrounds.main};
  box-sizing: border-box;
  text-align: center;
`

const IconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin-bottom: 20px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.main.primary100};
`

const LockIcon = styled.svg`
  width: 28px;
  height: 28px;
  fill: ${({ theme }) => theme.colors.main.primary500};
`

const StatusBadge = styled.span`
  display: inline-block;
  margin-bottom: 16px;
  padding: 6px 14px;
  border-radius: 4px;
  font-family: Arial, sans-serif;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.main.grey800};
  background: ${({ theme }) => theme.colors.backgrounds.app};
  border: 1px solid ${({ theme }) => theme.colors.main.grey300};
`

const ContentBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 420px;
`

const Title = styled.h2`
  margin: 0 0 12px;
  font-family: Arial, sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.main.grey900};
`

const Description = styled.p`
  margin: 0;
  font-family: Arial, sans-serif;
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;
  color: ${({ theme }) => theme.colors.main.grey700};
`

const ContactNote = styled.p`
  margin: 16px 0 0;
  padding: 14px 16px;
  width: 100%;
  border-radius: 6px;
  font-family: Arial, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.main.grey800};
  background: ${({ theme }) => theme.colors.backgrounds.app};
  box-sizing: border-box;
`
